export enum LOAN_SUGGESTED_TERM {
    IN_PROGRESS = 'In Progress', 
    MODIFIED = 'Modified', 
    REJECTED = 'Rejected', 
    ACCEPTED = 'Accepted', 
    WITHDRAWN = 'Withdrawn'
}

export class UserSuggestedTerm {
    public _id:  string;
    public investedAmount: number;
    public lenderId: string;
    public portfolioId: string;
    public name: string;
    public lenderSuggestedRate: number;
    public lenderSuggestedTenure: number;
    public borrowerSuggestedRate: number;
    public borrowerSuggestedTenure: number;
    public lenderStatus: LOAN_SUGGESTED_TERM;
    public borrowerStatus: LOAN_SUGGESTED_TERM;
    public comment: string;
    public readonly createdAt: string;
    public readonly updatedAt: string;

    constructor(
        investedAmount: number,
        lenderId: string,
        portfolioId: string,
        name: string,
        lenderSuggestedRate: number,
        lenderSuggestedTenure: number,
        borrowerSuggestedRate: number,
        borrowerSuggestedTenure: number,
        lenderStatus: LOAN_SUGGESTED_TERM,
        borrowerStatus: LOAN_SUGGESTED_TERM,
        comment: string,
        _id?: string
    ) {
        this.investedAmount = investedAmount;
        this.lenderId = lenderId;
        this.portfolioId = portfolioId;
        this.name = name;
        this.lenderSuggestedRate = lenderSuggestedRate;
        this.lenderSuggestedTenure = lenderSuggestedTenure;
        this.borrowerSuggestedRate = borrowerSuggestedRate;
        this.borrowerSuggestedTenure = borrowerSuggestedTenure;
        this.lenderStatus = lenderStatus;
        this.borrowerStatus = borrowerStatus;
        this.comment = comment;
        this._id = _id
    }
}

export class LoanSuggestedTerm {
    public readonly _id: string;
    public readonly loanId: string;
    public readonly generatedLoanId: string;
    public readonly name: string;
    public readonly profile: string;
    public readonly loanAmount: number;
    public readonly roi: number;
    public readonly loanTenure: number;
    public readonly rating: string;
    public readonly loanSanctionStatus: string;
    public readonly runnerStatus: string;
    public userSuggestedTerms: UserSuggestedTerm[];
    public readonly createdAt: string;
    public readonly updatedAt: string;

    constructor(
        loanId: string,
        generatedLoanId: string,
        name: string,
        profile: string,
        loanAmount: number,
        roi: number,
        loanTenure: number,
        rating: string,
        loanSanctionStatus: string,
        runnerStatus: string,
        userSuggestedTerms: UserSuggestedTerm[],
        id?: string
    ) {
        this.loanId = loanId;
        this.generatedLoanId = generatedLoanId;
        this.name = name;
        this.profile = profile,
        this.loanAmount = loanAmount;
        this.roi = roi;
        this.loanTenure = loanTenure;
        this.rating = rating;
        this.loanSanctionStatus = loanSanctionStatus;
        this.runnerStatus = runnerStatus;
        this.userSuggestedTerms = userSuggestedTerms;
        this._id = id;
    }

    public static createFrom(obj: Partial<LoanSuggestedTerm>): LoanSuggestedTerm {
        const loanSuggestedTerms = new LoanSuggestedTerm(
            obj.loanId,
            obj.generatedLoanId,
            obj.name,
            obj.profile,
            obj.loanAmount,
            obj.roi,
            obj.loanTenure,
            obj.rating,
            obj.loanSanctionStatus,
            obj.runnerStatus,
            obj.userSuggestedTerms || [],
            obj._id
        );
        return loanSuggestedTerms;
    }
}
